(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sah-home-feature"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sah-inline-video')) {
  customElements.define('sah-inline-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      this.started = false;
      this.pending = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.video.autoplay = true;
      this.mobile = matchMedia('(max-width:767px)');
      const options = { signal: this.events.signal };
      const updateControls = () => {
        this.video.controls = !this.mobile.matches;
        this.video.disablePictureInPicture = this.mobile.matches;
        this.video.disableRemotePlayback = this.mobile.matches;
        this.button.hidden = !this.mobile.matches;
      };
      const updateLabel = () => {
        this.button.textContent = this.video.paused ? this.button.dataset.play : this.button.dataset.pause;
      };
      this.mobile.addEventListener('change', updateControls, options);
      this.video.addEventListener('playing', () => {
        this.started = true;
        this.observer?.disconnect();
        updateLabel();
      }, options);
      this.video.addEventListener('pause', updateLabel, options);
      this.button.addEventListener('click', () => {
        this.started = true;
        if (this.video.paused) this.video.play()?.catch(() => updateLabel());
        else this.video.pause();
      }, options);
      this.video.addEventListener('loadeddata', () => this.tryPlayback(), options);
      this.video.addEventListener('canplay', () => this.tryPlayback(), options);
      document.addEventListener('visibilitychange', () => this.tryPlayback(), options);
      window.addEventListener('pageshow', () => this.tryPlayback(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(() => this.tryPlayback(), { threshold: [0, 0.1] });
        this.observer.observe(this.video);
      }
      updateControls();
      updateLabel();
      this.tryPlayback();
    }
    tryPlayback() {
      if (this.started || this.pending || document.hidden || !this.isConnected) return;
      const box = this.video.getBoundingClientRect();
      if (!box.width || !box.height || box.bottom <= 0 || box.top >= innerHeight) return;
      this.pending = true;
      const playback = this.video.play();
      if (playback?.then) playback.catch(() => {}).finally(() => { this.pending = false; });
      else this.pending = false;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
    }
  });
}

if (!customElements.get('sah-review-rotation')) {
  customElements.define('sah-review-rotation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const source = this.querySelector('[data-review-source]');
      const target = this.querySelector('[data-review-cards]');
      if (!source || !target) return;
      const seen = new Set();
      const reviews = [...source.content.querySelectorAll('.jdgm-carousel-item')].filter(item => {
        const rating = item.querySelector('.jdgm-carousel-item__review-rating');
        const id = item.dataset.reviewId;
        if (!rating || rating.querySelectorAll('.jdgm--on').length !== 5 || rating.querySelector('.jdgm--half') || (id && seen.has(id))) return false;
        if (id) seen.add(id);
        return true;
      }).map(item => {
        const stamp = item.querySelector('[data-time]')?.dataset.time || '';
        const parts = stamp.split('/').map(Number);
        return {
          text: (item.querySelector('.jdgm-carousel-item__review-body')?.textContent || item.querySelector('.jdgm-carousel-item__review-title')?.textContent || '').trim(),
          name: (item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || '').trim(),
          date: parts.length === 3 ? new Date(parts[2], parts[0] - 1, parts[1]).getTime() : 0
        };
      }).filter(item => item.text).sort((a, b) => b.date - a.date);
      target.replaceChildren();
      if (!reviews.length) { this.closest('.sah-home--reviews').hidden = true; return; }
      this.closest('.sah-home--reviews').hidden = false;
      for (const review of reviews) {
        const card = document.createElement('figure'); card.className = 'sah-home__review';
        const stars = document.createElement('p'); stars.className = 'sah-home__stars'; stars.textContent = '★★★★★'; stars.setAttribute('aria-label', this.dataset.starLabel);
        const quote = document.createElement('blockquote'); quote.textContent = review.text;
        const name = document.createElement('figcaption'); name.textContent = review.name;
        card.append(stars, quote, name); target.append(card);
      }
      this.cards = [...target.children]; this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.toggle = this.querySelector('[data-review-toggle]');
      this.querySelector('[data-review-prev]').addEventListener('click', () => this.advance(-1), { signal });
      this.querySelector('[data-review-next]').addEventListener('click', () => this.advance(1), { signal });
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.paint(); }, { signal });
      window.addEventListener('resize', () => this.paint(), { signal });
      this.paint();
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.advance(1);
      }, 8000);
    }
    advance(direction) { this.index = (this.index + direction * this.size + this.cards.length) % this.cards.length; this.paint(); }
    paint() {
      this.size = matchMedia('(max-width: 767px)').matches ? 1 : 3;
      const visible = new Set(Array.from({ length: Math.min(this.size, this.cards.length) }, (_, n) => (this.index + n) % this.cards.length));
      this.cards.forEach((card, n) => card.hidden = !visible.has(n));
      this.querySelector('[data-review-controls]').hidden = this.cards.length <= this.size;
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.toggle.setAttribute('aria-pressed', String(this.paused));
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sah-mission"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sah-story-browser'))customElements.define('sah-story-browser',class extends HTMLElement{
connectedCallback(){this.track=this.querySelector('.sah-mission__track');this.slides=[...this.querySelectorAll('.sah-mission__slide')];this.nav=this.querySelector('.sah-mission__navigation');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.count=this.querySelector('[data-count]');if(!this.track||!this.slides.length)return;this.events=new AbortController();const opts={signal:this.events.signal};this.index=0;this.nav.hidden=this.slides.length<2;const update=()=>{let best=Infinity;const left=this.track.getBoundingClientRect().left;this.slides.forEach((s,i)=>{const distance=Math.abs(s.getBoundingClientRect().left-left);if(distance<best){best=distance;this.index=i}});this.prev.disabled=this.index===0;this.next.disabled=this.index===this.slides.length-1;this.count.textContent=`${this.index+1} / ${this.slides.length}`};const settle=()=>{update();this.track.style.height=`${this.slides[this.index].offsetHeight+12}px`};this.track.addEventListener('scroll',()=>{clearTimeout(this.settleTimer);this.settleTimer=setTimeout(settle,180)},opts);this.track.addEventListener('scrollend',settle,opts);this.prev.addEventListener('click',()=>this.go(this.index-1),opts);this.next.addEventListener('click',()=>this.go(this.index+1),opts);this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}},opts);this.addEventListener('shopify:block:select',e=>{const i=this.slides.indexOf(e.target.closest('.sah-mission__slide'));if(i>=0)this.go(i)},opts);this.resize=new ResizeObserver(settle);this.slides.forEach(slide=>this.resize.observe(slide));settle()}
go(i){i=Math.max(0,Math.min(i,this.slides.length-1));const left=this.slides[i].offsetLeft-this.slides[0].offsetLeft;this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}
disconnectedCallback(){clearTimeout(this.settleTimer);this.events?.abort();this.resize?.disconnect()}
});

  } catch(e) { console.error(e); }
})();
})();
